export default __webpack_public_path__ + "static/media/ie.9e3414e8.svg";